import MenuBar from './menuBar';
import OpenMenuBtn from './openMenuBtn';

function Menu() {
  return (
    <>
      <OpenMenuBtn />
      <MenuBar />
    </>
  );
}
export default Menu;
